import { render, staticRenderFns } from "./PerformancePersonDetail.vue?vue&type=template&id=990ca5a6&scoped=true&"
import script from "./PerformancePersonDetail.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990ca5a6",
  null
  
)

export default component.exports